import React from "react"
import { Button, Text } from "@chakra-ui/react"
import { Icon } from "../../"

export default function ShowAllButton({ postLimit, showAllPosts }) {
  const disabledProps = {
    _active: { bg: null },
    _hover: { bg: null },
    isDisabled: true,
    as: "a",
  }

  return (
    <Button
      {...(postLimit === null && { ...disabledProps })}
      onClick={() => showAllPosts()}
      variant="primary"
      size="sm"
    >
      {postLimit === null ? (
        <Text as="span" lineHeight={1} size="sm" fontWeight="bold">
          No more posts
        </Text>
      ) : (
        <>
          <Text as="span" lineHeight={1} size="sm" fontWeight="bold">
            Show All
          </Text>
          <Icon name="add" ml={2} boxSize={3} />
        </>
      )}
    </Button>
  )
}
